import { Button, Form, Input, Select, Spin } from 'antd';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { useCallback, useEffect, useState } from 'react';
import { ClientsService } from 'services/ClientsService';
import { requiredRule } from 'utils/forms/validationRules';
import _debounce from 'lodash/debounce';
import { Center } from 'ui/Center';
import { useTribe } from 'hooks/useTribe';

const SEARCH_DELAY = 800;

function ClientsForm({ initialValues, onSubmit }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [clients, setClients] = useState([]);
  const tribe_id = useTribe();

  useEffect(() => {
    if (!initialValues) {
      resetState();
    } else {
      prePopulateForm();
    }
  }, [initialValues]);

  useEffect(() => {
    if (search) {
      fetchClients();
    }
  }, [search]);

  const prePopulateForm = () => {
    const { title, clients_ids } = initialValues;

    form.setFieldsValue({
      title,
      clients_ids,
    });

    fetchClients(clients_ids);
  };

  const fetchClients = async (clientIds = []) => {
    setLoading(true);

    try {
      const items = await ClientsService.getSearchedClients(
        search,
        clientIds,
        tribe_id
      );

      setClients(items);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const debouncedSearchFn = useCallback(
    _debounce(handleSearch, SEARCH_DELAY),
    []
  );

  const handleSubmit = (values) => {
    onSubmit(values, resetState);
  };

  const resetState = () => {
    form.resetFields();
    setClients([]);
    setSearch('');
  };

  return (
    <Form
      form={form}
      layout="horizontal"
      labelAlign="right"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      onFinish={handleSubmit}
    >
      <Form.Item name="title" label="Название сегмента" rules={[requiredRule]}>
        <Input allowClear placeholder="Введите название" />
      </Form.Item>

      <Form.Item name="clients_ids" label="Клиенты" rules={[requiredRule]}>
        <Select
          showSearch
          allowClear
          filterOption={false}
          placeholder="Выберите клиента"
          mode="multiple"
          onSearch={debouncedSearchFn}
          dropdownRender={(menu) => (
            <>
              {menu}
              {loading && (
                <Center>
                  <Spin spinning={loading} />
                </Center>
              )}
            </>
          )}
        >
          {clients?.map(({ full_name, id }) => (
            <Select.Option key={id} value={id}>
              {full_name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { ClientsForm };
